<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الأخبار </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3"> تفعيل بروتوكول التعاون الموقع مع وزارة الخارجية وإستخراج بطاقات رقم
                            قومى للمواطنين المقيمين خارج البلاد </h1>

                        <p>
                            تنفيذا لتوجيهات السيد الفاضل اللواء وزير الداخليه وموافقه سيادته على تنفيذ خطه تطوير اداء
                            القطاع والارتقاء بالخدمات المقدمه لجمهور المواطنين والتيسير عليهم لمواجهه التحديات والمعوقات
                            التى تؤثر على منظومه العمل بقطاع الاحوال المدنية وبناء على توجيهات السيد اللواء مساعد الوزير
                            لقطاع الاحوال المدنية تم تنفيذ الاتى :
                            <br>
                            تفعيل بروتوكول التعاون الموقع مع وزارة الخارجية وإستخراج بطاقات رقم قومى للمواطنين المقيمين
                            خارج البلاد اذكاءً لروح المواطنة
                        </p>


                        <img src="@/assets/images/innerImage.jpg" alt="" class="img-fluid py-3">
                    </div>

                </div>
            </div>
        </div>
    </section>




</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'News7Comp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}
</script>